// 横スクロール（CSS scroll-snap）に前後ボタンとドットを付ける: [data-mp-snap]
//   [data-mp-snap-track] スクロールする要素 / [data-mp-snap-prev|next] / [data-mp-snap-dot="番号"]
// 表示中のカードに .is-current とドットの aria-current を付け、先頭では前へ・最後では次へのボタンを隠す（hidden）。
// 動いたら root に .is-ready を付ける（CSS はそのときだけ表示中以外のカードを薄くする）。
// タブ（tabs.js）の中にあるときは、タブを切り替えたら先頭へ戻す。
// スクロールするかどうか（SP だけ等）は CSS が決める。スクロールしない幅ではボタンも CSS で隠す。

import { reduceMotion } from './reveal.js';

function setupSnapNav(root) {
  const track = root.querySelector('[data-mp-snap-track]');
  const items = track ? [...track.children] : [];
  if (items.length < 2) return;
  const dots = [...root.querySelectorAll('[data-mp-snap-dot]')];
  const prev = root.querySelector('[data-mp-snap-prev]');
  const next = root.querySelector('[data-mp-snap-next]');

  const offset = (i) => items[i].offsetLeft - items[0].offsetLeft;
  const current = () =>
    items.reduce((best, _, i) => (Math.abs(offset(i) - track.scrollLeft) < Math.abs(offset(best) - track.scrollLeft) ? i : best), 0);
  const go = (i) => {
    const index = Math.max(0, Math.min(items.length - 1, i));
    track.scrollTo({ left: offset(index), behavior: reduceMotion ? 'auto' : 'smooth' });
  };
  // 隠すボタンにフォーカスがあったら、もう一方へ移す（フォーカスを失わせない）
  const toggle = (button, hide, fallback) => {
    if (!button || button.hidden === hide) return;
    if (hide && document.activeElement === button) fallback?.focus();
    button.hidden = hide;
  };
  const update = () => {
    const index = current();
    items.forEach((item, i) => item.classList.toggle('is-current', i === index));
    dots.forEach((dot, i) => {
      if (i === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    toggle(prev, index === 0, next);
    toggle(next, index === items.length - 1, prev);
  };

  prev?.addEventListener('click', () => go(current() - 1));
  next?.addEventListener('click', () => go(current() + 1));
  dots.forEach((dot) => dot.addEventListener('click', () => go(Number(dot.dataset.mpSnapDot))));
  track.addEventListener('scroll', update, { passive: true });
  root.classList.add('is-ready');
  update();
  root.closest('[data-mp-tabs]')?.addEventListener('mp:tabchange', () => {
    track.scrollLeft = 0;
    update();
  });
}

export function setupSnapNavs() {
  document.querySelectorAll('[data-mp-snap]').forEach(setupSnapNav);
}
